<template>
  <transition name="slide">
    <div
      class="message-wrap"
      :class="[type, center ? 'text-center' : '']"
      :style="{ ...style }"
      v-if="visible"
    >
      <div v-if="messageArr.length" class="message-line">
        <div
          v-for="(item, index) in messageArr"
          :key="index"
          class="message-line-item"
        >
          {{ item }}
        </div>
      </div>
      <div v-else class="message">{{ message }}</div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      // 消息内容
      message: '',
      messageArr: '',
      // 是否显示组件
      visible: false,
      // 'success','error'
      type: 'info',
      // 定时器时长
      duration: 2000,
      // 文本是否居中
      center: false,
      // 自定义 style
      style: {},
    }
  },
  created() {
    const arr = this.message.split('\n')
    if (arr.length > 1) {
      this.messageArr = arr
    }
  },
  mounted() {
    this.startTimer()
  },
  methods: {
    startTimer() {
      setTimeout(() => {
        this.visible = false
      }, this.duration)
    },
  },
}
</script>

<style lang="less" scoped>
.message-wrap {
  position: fixed;
  top: 100px;
  left: 50%;
  color: #333;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  transform: translateX(-50%);
  z-index: 2023;

  .message {
    display: flex;
    justify-content: center;
    padding: 8px 15px;
    font-size: 14px;
    border-radius: 4px;
  }
}

.sucess {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #e1f3d8;
}

.error {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fde2e2;
}

.info {
  // color: #e6a23c;
  // background: #fdf6ec;
  // border-color: #faecd8;
  color: #fff;
  background: #000;
  opacity: 0.7;
  border-color: #000;
}
</style>
